import { render, staticRenderFns } from "./FullscreenSlider.vue?vue&type=template&id=4308c4b7&scoped=true"
import script from "./FullscreenSlider.vue?vue&type=script&lang=js"
export * from "./FullscreenSlider.vue?vue&type=script&lang=js"
import style0 from "./FullscreenSlider.vue?vue&type=style&index=0&id=4308c4b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4308c4b7",
  null
  
)

export default component.exports